import Header from './VbzWorksheetHeader.vue';
import moduleId from './moduleId';
import WorksheetView from '@/modules/customerVbzWorksheet/views/WorksheetView.vue';
import ReportingView from '@/modules/customerVbzWorksheet/views/ReportingView.vue';
import VbzAdminView from '@/modules/customerVbzWorksheet/views/VbzAdminView.vue';
import worksheetService from '@/modules/customerVbzWorksheet/worksheetService';
import store from '@/store';

// Be sure the route names map the names given in ui-config/moduls/[0]/viewsRestrictedToOneOfGroup
// with a worksheet- prefix
export const ROUTE_NAMES = {
  dispo: 'worksheet-dispo',
  zueri9CustomerView: 'worksheet-zueri9CustomerView',
  zueri9: 'worksheet-zueri9',
  admin: 'worksheet-admin',
  reporting: 'worksheet-reporting',
};
class VbzWorksheetRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/worksheet',
        name: 'worksheet-home',
        redirect: (to) => {
          // the function receives the target route as the argument
          // we return a redirect path/location here.
          console.debug('redirect to dispo');
          return { path: '/worksheet/dispo' };
        },

        meta: { moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: true, hideFooter: true },
      },
      {
        path: '/worksheet/dispo',
        name: ROUTE_NAMES.dispo,
        meta: { wsConfigKey: 'dispo', moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: true, hideFooter: true },
        components: { default: WorksheetView, header: Header },
        isPermitted: (user, userGroups) => {
          return isPermitted(user, userGroups, 'dispo');
        },
      },
      {
        path: '/worksheet/zueri9-customer-view',
        name: ROUTE_NAMES.zueri9CustomerView,
        meta: { wsConfigKey: 'zueri9CustomerView', moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: true, hideFooter: true },
        components: { default: WorksheetView, header: Header },
        isPermitted: (user, userGroups) => {
          return isPermitted(user, userGroups, 'zueri9CustomerView');
        },
      },
      {
        path: '/worksheet/zueri9',
        name: ROUTE_NAMES.zueri9,
        meta: { wsConfigKey: 'zueri9', moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: true, hideFooter: true },
        components: { default: WorksheetView, header: Header },
        isPermitted: (user, userGroups) => {
          return isPermitted(user, userGroups, 'zueri9');
        },
      },
      {
        path: '/worksheet/reporting',
        name: 'worksheet-reporting',
        meta: { wsConfigKey: 'reporting', moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: true, hideFooter: true },
        components: { default: ReportingView, header: Header },
        isPermitted: (user, userGroups) => {
          return isPermitted(user, userGroups, 'reporting');
        },
      },
      {
        path: '/worksheet/admin',
        name: 'worksheet-AdminView',
        meta: { wsConfigKey: 'admin', moduleType, initiateSyncBeforeNav: false, moduleId, baseRoute: true, hideFooter: true },
        components: { default: VbzAdminView, header: Header },
        isPermitted: (user, userGroups) => {
          return isPermitted(user, userGroups, 'admin');
        },
      },
    ];
  };
  async beforeNavigationTo({ moduleState, moduleConfig, from, to, next }) {
    let user = JSON.parse(localStorage.getItem('user') || '{}');
    let { groups } = user;

    let requiredGroups = moduleConfig.viewsRestrictedToOneOfGroup[`${to.meta.wsConfigKey}`];
    console.debug('beforeNavigationTo in worksheet', to.name, requiredGroups);

    let shouldContinue = worksheetService.isUserPermittedWhenRestrictedToGroups(groups, requiredGroups);
    return { shouldContinue };
  }
}
const routeHandler = new VbzWorksheetRouteHandler();
const getModuleConfig = (moduleType, moduleInstance) => {
  let moduleTypeAndInstance = moduleType + (moduleInstance ? `_${moduleInstance}` : '');
  return store.state.configs.moduleConfigsByModuleTypeAndInstance[moduleTypeAndInstance];
};

function isPermitted(user, userGroups, routeConfigName) {
  let moduleConfig = getModuleConfig('VbzWorksheet');
  let requiredGroups = moduleConfig.viewsRestrictedToOneOfGroup[routeConfigName];
  console.debug(`isPermitted ${routeConfigName} ${JSON.stringify(userGroups, null, 2)} ${JSON.stringify(requiredGroups, null, 2)}`);
  return worksheetService.isUserPermittedWhenRestrictedToGroups(userGroups, requiredGroups);
}
export default routeHandler;
